import React from 'react'

export type MapEditorContextProps = {
  isMapEditor: boolean
}

export const MapEditorContext = React.createContext<MapEditorContextProps | undefined>(undefined)

export const useMapEditor = () => {
  const result = React.useContext(MapEditorContext)
  if (!result) {
    throw new Error('No MapEditorContextProvider found')
  }
  return result
}

export const useIsMapEditor = () => {
  const mapEditorContext = React.useContext(MapEditorContext)
  return mapEditorContext !== undefined
}
